import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/layout'
import Page from '@/views/page/page'

Vue.use(Router)

export const constantRouterMap = [{
    path: '',
    component: Layout,
    redirect: '/layout/home'
  },

  // 报表
  {
    path: '/layout',
    component: Layout,
    meta: {
      title: 'layout',
      icon: 'layout',
      keepAlive: true
    },
    children: [{
      path: 'home',
      name: '智慧食堂',
      component: () => import('@/views/home/home'),
      meta: {
        title: 'home',
        icon: 'home',
        keepAlive: true
      }
    }, {
      path: 'my',
      name: '我的',
      component: () => import('@/views/my/my'),
      meta: {
        title: 'my',
        icon: 'my',
        keepAlive: true
      }
    }]
  },
  {
    path: '/wallet',
    name: '我的钱包',
    component: () => import('@/views/wallet/wallet'),
    meta: {
      title: 'wallet',
      icon: 'wallet',
      keepAlive: false
    }
  },
  {
    path: '/page',
    component: Page,
    meta: {
      title: 'page',
      icon: 'page',
      keepAlive: true
    },
    children: [{
        path: 'userinfo',
        name: '个人信息',
        component: () => import('@/views/userinfo/userinfo'),
        meta: {
          title: 'userinfo',
          icon: 'userinfo'
        }
      }, {
        path: 'orderlist',
        name: '订单列表',
        component: () => import('@/views/orderlist/orderlistsub'),
        meta: {
          title: 'orderlist',
          icon: 'orderlist',
          keepAlive: true
        }
      }, {
        path: 'periods',
        name: '订餐计划',
        component: () => import('@/views/periods/periods'),
        meta: {
          title: 'periods',
          icon: 'periods',
          keepAlive: true
        }
      }, {
        path: 'ordermeal',
        name: '预订餐',
        component: () => import('@/views/ordermeal/ordermeal'),
        meta: {
          title: 'ordermeal',
          icon: 'ordermeal',
          keepAlive: false
        }
      }, {
        path: 'confirmorder',
        name: '确认订单',
        component: () => import('@/views/confirmorder/confirmorder'),
        meta: {
          title: 'confirmorder',
          icon: 'confirmorder',
          keepAlive: true
        }
      }, {
        path: 'pay',
        name: '支付',
        component: () => import('@/views/pay/pay'),
        meta: {
          title: 'pay',
          icon: 'pay',
          keepAlive: false
        }
      }, {
        path: 'paysuccess',
        name: '支付成功',
        component: () => import('@/views/paysuccess/paysuccess'),
        meta: {
          title: 'paysuccess',
          icon: 'paysuccess',
          keepAlive: false
        }
      },
      {
        path: 'qrcode',
        name: '取餐码',
        component: () => import('@/views/qrcode/qrcode'),
        meta: {
          title: 'qrcode',
          icon: 'qrcode',
          keepAlive: false
        }
      }, {
        path: 'monthbill',
        name: '月账单',
        component: () => import('@/views/monthbill/monthbill'),
        meta: {
          title: 'monthbill',
          icon: 'monthbill',
          keepAlive: false
        }
      }, {
        path: 'amonthbill',
        name: '收支记录',
        component: () => import('@/views/amonthbill/amonthbill'),
        meta: {
          title: 'amonthbill',
          icon: 'amonthbill',
          keepAlive: false
        }
      }, {
        path: 'rechargedetail',
        name: '充值详情',
        component: () => import('@/views/rechargedetail/rechargedetail'),
        meta: {
          title: 'rechargedetail',
          icon: 'rechargedetail',
          keepAlive: false
        }
      },
      {
        path: 'orderdetail',
        name: '订单详情',
        component: () => import('@/views/orderdetail/orderdetail'),
        meta: {
          title: 'orderdetail',
          icon: 'orderdetail',
          keepAlive: false
        }
      }, {
        path: 'bindingface',
        name: '绑定人脸',
        component: () => import('@/views/bindingface/bindingface'),
        meta: {
          title: 'bindingface',
          icon: 'bindingface',
          keepAlive: false
        }
      }, {
        path: 'login',
        name: '登录',
        component: () => import('@/views/login/login'),
        meta: {
          title: 'login',
          icon: 'login',
          keepAlive: false
        }
      },
      {
        path: 'preprocessing',
        name: '专户申请',
        component: () => import('@/views/preprocessing/preprocessing'),
        meta: {
          title: 'preprocessing',
          icon: 'preprocessing',
          keepAlive: false
        }
      }, {
        path: 'rechargeNotReceived',
        name: '充值未到账',
        component: () => import('@/views/rechargeNotReceived/rechargeNotReceived'),
        meta: {
          title: 'rechargeNotReceived',
          icon: 'rechargeNotReceived',
          keepAlive: false
        }
      },
      {
        path: 'rechargeNoDetail',
        name: '充值到账详情',
        component: resolve => require(['@/views/rechargeNotReceived/rechargeNoDetail'], resolve)
      }, {
        path: 'changepassword',
        name: '修改密码',
        component: () => import('@/views/changepassword/changepassword'),
        meta: {
          title: 'changepassword',
          icon: 'changepassword',
          keepAlive: true
        }
      },
      {
        path: 'changephone',
        name: '绑定手机',
        component: () => import('@/views/changephone/changephone'),
        meta: {
          title: 'changephone',
          icon: 'changephone',
          keepAlive: true
        }
      }, {
        path: 'backpassword',
        name: '找回密码',
        component: () => import('@/views/backpassword/backpassword'),
        meta: {
          title: 'backpassword',
          icon: 'backpassword',
          keepAlive: true
        }
      }, {
        path: 'addressList',
        name: '地址列表',
        component: () => import('@/views/address/addressList'),
        meta: {
          title: 'addressList',
          icon: 'addressList',
          keepAlive: true
        }
      }, {
        path: 'addressEdit',
        name: '地址信息',
        component: () => import('@/views/address/addressEdit'),
        meta: {
          title: 'addressEdit',
          icon: 'addressEdit',
          keepAlive: false
        }
      },
      {
        path: 'rate',
        name: '评价',
        component: () => import('@/views/rate/rate'),
        meta: {
          title: 'rate',
          icon: 'rate',
          keepAlive: false
        }
      }
    ]
  }
]

export const asyncRouterMap = [{
    path: '/permission',
    component: Layout,
    redirect: '/permission/page',
    name: 'permission',
    alwaysShow: true, // will always show the root menu
    meta: {
      title: 'permission',
      icon: 'lock',
      roles: ['admin', 'editor'] // you can set roles in root nav
    },
    children: [{
      path: 'page',
      component: () => import('@/views/permission/page'),
      name: 'pagePermission',
      meta: {
        title: 'pagePermission',
        roles: ['admin'] // or you can only set roles in sub nav
      }
    }, {
      path: 'directive',
      component: () => import('@/views/permission/directive'),
      name: 'directivePermission',
      meta: {
        title: 'directivePermission'
        // if do not set roles, means: this page does not require permission
      }
    }]
  },
  {
    path: '/error',
    component: Layout,
    redirect: 'noredirect',
    name: 'errorPages',
    meta: {
      title: 'errorPages',
      icon: '404'
    },
    children: [{
      path: '404',
      component: () => import('@/views/errorPage/404'),
      name: 'page404',
      meta: {
        title: 'page404',
        noCache: true
      }
    }]
  },
  // 错误日志
  {
    path: '/errorLog',
    component: Layout,
    children: [{
      path: 'errorLog',
      name: 'errorLog',
      component: () => import('@/views/errorLog/errorLog'),
      meta: {
        title: 'Errorlog',
        icon: 'errorLog'
      }
    }]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js